/**
* This file was automatically generated by quicktype.
* DO NOT MODIFY IT BY HAND. Instead, modify the source JSONSchema file,
* and run command(npm run schemabuild) to regenerate this file.
*/
/**
 * 跨端消息的KEY: lancer-address-slim: 地址信息通信(lancer和lancer-slim之间);lancer-spark-slim:
 * 上心信息通信(lancer和lancer-slim之间);lancer-invoice-slim: 发票信息通信(lancer和lancer-slim之间);
 */
export var EventKey;
(function (EventKey) {
    EventKey["LancerAddressSlim"] = "lancer-address-slim";
    EventKey["LancerInvoiceSlim"] = "lancer-invoice-slim";
    EventKey["LancerSparkSlim"] = "lancer-spark-slim";
    EventKey["Test"] = "test";
})(EventKey || (EventKey = {}));
